module.exports = __webpack_public_path__ + "static/rend1-02a4cdf0d9bec8b69ce7c3e9ed0e6d53.png";